import { render } from "./SubNavigationItem.vue?vue&type=template&id=671d87fc"
import script from "./SubNavigationItem.vue?vue&type=script&lang=js"
export * from "./SubNavigationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__